{
  "settings": {
    "title": "User Settings",
    "profileTitle": "Profile",
    "profileSettings": "Profile Settings",
    "memberSince": "Member since {{date}}",
    "profile": {
      "title": "Profile",
      "email": "Email",
      "firstName": "First Name",
      "lastName": "Last Name",
      "save": "Save Changes"
    },
    "personalInfo": {
      "title": "Personal Information"
    },
    "bodyMetrics": {
      "title": "Body Metrics",
      "weight": "Weight",
      "weightUnit": "kg",
      "height": "Height",
      "heightUnit": "cm",
      "calorieGoal": "Daily Calorie Goal",
      "calorieGoalUnit": "kcal",
      "gender": "Gender",
      "sourceAppleHealth": "Apple Health",
      "sourceHealthConnect": "Health Connect",
      "sourceManual": "Manual",
      "bodyFat": "Body fat",
      "muscle": "Muscle",
      "bmi": "BMI",
      "latestComposition": "Latest composition",
      "viewTrend": "View body composition trend",
      "notAvailable": "N/A"
    },
    "integrations": {
      "title": "Connected data",
      "appleHealth": "Apple Health",
      "healthConnect": "Health Connect",
      "description": "Heart rate, calories & body metrics",
      "caption": "Works with Apple Watch, Garmin and smart scales.",
      "connect": "Connect",
      "connecting": "Connecting…",
      "connected": "Connected",
      "partiallyConnected": "Partially connected",
      "manage": "Manage"
    },
    "gender": {
      "MALE": "Male",
      "FEMALE": "Female",
      "OTHER": "Other",
      "PREFER_NOT_TO_SAY": "N/A"
    },
    "fitnessGoal": {
      "title": "Fitness Goal",
      "GAIN_WEIGHT": "Gain Weight",
      "LOSE_WEIGHT": "Lose Weight",
      "STAY_FIT": "Stay Fit"
    },
    "activityLevel": {
      "title": "Activity Level",
      "NOT_ACTIVE": "Not Active",
      "NOT_ACTIVE_DESC": "Little to no exercise",
      "LIGHTLY_ACTIVE": "Lightly Active",
      "LIGHTLY_ACTIVE_DESC": "Exercise 1-3 days/week",
      "ACTIVE": "Active",
      "ACTIVE_DESC": "Exercise 4-5 days/week",
      "VERY_ACTIVE": "Very Active",
      "VERY_ACTIVE_DESC": "Exercise 6-7 days/week"
    },
    "dangerZone": {
      "title": "Danger Zone",
      "deleteAccount": "Delete Account",
      "deleteDescription": "Permanently delete your account and all data",
      "delete": "Delete",
      "confirmDelete": "Are you sure?",
      "deleteWarning": "This action cannot be undone. All your data will be permanently deleted.",
      "confirmButton": "Yes, Delete",
      "cancelButton": "Cancel",
      "subscriptionActiveTitle": "Cancel your subscription first",
      "subscriptionActiveDescription": "You have an active subscription that will renew. Cancel it in the store before deleting your account, otherwise you'll keep being charged.",
      "manageSubscription": "Manage subscription"
    },
    "validation": {
      "firstNameRequired": "First name is required",
      "lastNameRequired": "Last name is required"
    }
  },
  "bodyComposition": {
    "title": "Body composition",
    "subtitle": "Track your body composition over time",
    "currentWeight": "Current weight",
    "weight": "Weight",
    "bodyFat": "Body fat",
    "muscle": "Muscle",
    "bmi": "BMI",
    "week": "Week",
    "month": "Month",
    "year": "Year",
    "sync": "Sync",
    "emptyTitle": "No measurements yet",
    "emptyBody": "Connect Apple Health or log your weight to start tracking body composition over time.",
    "connect": "Connect Apple Health",
    "errorTitle": "Couldn't load your measurements",
    "errorBody": "Check your connection and try again.",
    "retry": "Retry",
    "bmiHint": "Fill in your weight and height in your profile.",
    "addWeight": "Add weight",
    "logWeightTitle": "Log your weight",
    "logWeightSubtitle": "Add a manual reading to your body-composition history.",
    "logWeightSave": "Save"
  }
}
